import React from 'react';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { useNavigate } from 'react-router';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

type PageTitleProps = React.PropsWithChildren & {
  title: string;
  parents?: string[];
  onBack?: () => void;
  leftAlignedChildren?: React.ReactNode;
};

const PageTitle: React.FC<PageTitleProps> = ({
  title,
  parents = [],
  children,
  onBack,
  leftAlignedChildren,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="page-title d-flex align-items-end justify-content-between flex-column flex-sm-row">
      <div className="d-flex flex-column align-items-start">
        {parents.length > 0 ? (
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <StylishNewButton onClick={handleBack} customButton>
                  <SharedIcon iconName="keyboard_arrow_left" size="sm" />
                  Back
                </StylishNewButton>
              </li>
              {parents.map((parent, index) => (
                <li key={index} className="breadcrumb-item">
                  {parent}
                </li>
              ))}
            </ol>
          </div>
        ) : (
          <div className="mt-2"></div>
        )}
          <div className="d-flex align-items-center">
            <h1 className="me-3">{title}</h1>
            {leftAlignedChildren}
          </div>
      </div>
      {/**
       * NOTE: the spacing on the top of this right content might need tweaking
       * depending on the page
       */}
      <div className="right-content d-flex align-items-end">{children}</div>
    </div>
  );
};

export default PageTitle;
